'use client';

import Link from 'next/link';
import { useState } from 'react';
import type { RangeTile } from '@/lib/home-v2/data';
import { Indented, SectionHeading, WRAP } from './ui';

export function ColourMatch({ title, subtitle, tabs, num, colours }: {
  title: string; subtitle: string; num: string; tabs: { label: string; ranges: RangeTile[] }[]; colours: Record<string, string>;
}) {
  const colourOf = (name: string) => {
    const word = Object.keys(colours).find((k) => name.toLowerCase().includes(k.toLowerCase()));
    return word ? { key: word, hex: colours[word] } : null;
  };
  const usable = tabs.filter((t) => t.ranges.length > 0);
  const [active, setActive] = useState(0);
  if (usable.length === 0) return null;
  const ranges = usable[active].ranges;

  return (
    <section className={`${WRAP} pt-12 md:pt-20`}>
      <SectionHeading num={num} title={title} subtitle={subtitle}
        right={usable.length > 1 && (
          <div role="tablist" className="flex gap-2">
            {usable.map((t, k) => (
              <button key={t.label} role="tab" aria-selected={k === active} onClick={() => setActive(k)}
                className={`rounded-[10px] px-4 py-2 text-sm ${k === active ? 'bg-hv-orange font-semibold text-white' : 'border border-hv-line'}`}>{t.label}</button>
            ))}
          </div>
        )} />
      <Indented className="mt-6 md:mt-8">
        <ul className="grid grid-cols-4 gap-x-2 gap-y-3 md:grid-cols-8 lg:grid-cols-[repeat(16,minmax(0,1fr))]">
          {ranges.map((r) => {
            const c = colourOf(r.name);
            return (
              <li key={r.handle}>
                <Link href={`/${r.handle}`} className="flex flex-col gap-1.5 md:gap-2">
                  <span className="h-14 rounded-lg shadow-[inset_0_0_0_1px_rgba(0,0,0,0.06)] md:h-[120px] md:rounded-[10px]" style={{ background: c?.hex ?? '#E4DFD6' }} />
                  <span className="text-[11.5px] font-medium capitalize md:text-[13px]">{c?.key ?? r.name}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </Indented>
    </section>
  );
}
